const inputMin = 0
const inputMax = 1000

jQuery(function($) {
    $('.quantity').each(function() {
        const increasButton = $(this).find('#plus-btn');
        const decreaseButton = $(this).find('#minus-btn');

        increasButton.on('click',increaseNumber);
        decreaseButton.on('click', decreaseNumber);
    });

    $(document.body).on('wc_cart_emptied', cartEmptied);

});

/**
 * When Cart has been emptied we need to make sure that cart form and cart collaterals in /cart page are removed.
 *
 * @param {Event} e
 */
 function cartEmptied(e) {
    var cartForm = jQuery('.woocommerce-cart-form');
    var cartCollaterals = jQuery('.cart-collaterals');

    if (cartForm.length > 0) {
        cartForm.remove();
    }

    if (cartCollaterals.length > 0) {
        cartCollaterals.remove();
    }
}

/**
 * Decrease the product count number
 */
 function decreaseNumber() {
    const value = jQuery(this).parent().find('.input-text').val();
    jQuery(this).parent().find('.input-text').val(clampNumber(parseInt(value) - 1, inputMin, inputMax));
    jQuery('.actions').find('button').trigger('click');
}

/**
 * Increase the product count number
 */
function increaseNumber() {
    const value = jQuery(this).parent().find('.input-text').val();
    jQuery(this).parent().find('.input-text').val(clampNumber(parseInt(value) + 1, inputMin, inputMax));
    jQuery('.actions').find('button').trigger('click');
}

const clampNumber = (num, minimum, maximum) =>
Math.max(Math.min(num, Math.max(minimum, maximum)), Math.min(minimum, maximum))
